export default "__VITE_ASSET__DMF1mT4g__"